export const formatMoney = (amount: string | number, decimalCount = 0) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimalCount,
    maximumFractionDigits: decimalCount
  });

  const number =
    typeof amount === 'string'
      ? parseFloat(amount.replace(/[^\d.]/g, ''))
      : amount;
  return formatter.format(number);
};

export const formatPricingFromMinAndMax = (min: number, max: number) => {
  if (min === max) {
    return formatMoney(min);
  }
  return `${formatMoney(min)} - ${formatMoney(max)}`;
};

export const getAverageFromMinAndMax = (min: number, max: number) => {
  if (!min || !max) return 0;
  const avg = (min + max) / 2;
  return formatMoney(avg);
};

export const formatNumber = (num: number) => {
  return new Intl.NumberFormat().format(num);
};

// Convert any number in the thousands to a string with a K suffix
// e.g. 1000 => '1K'
// e.g. 2000 => '2K'
// e.g. 2500 => '2.5K'
export const formatNumberToK = (num: number) => {
  if (num < 1000) return num.toString();
  const k = num / 1000;
  const rounded = Math.round(k * 10) / 10;
  return `${rounded}K`;
};

/**
 * Rounds a number to a specified precision
 * @param value - The number to round
 * @param precision - The precision to round to
 * @returns The rounded number
 */
export const round = (value: number, precision = 0) => {
  const multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
};

/**
 * Converts a number from 0-100 to a scale of 0-10
 * @param value - The number to convert
 * @returns The converted number
 */
export const convertZeroToHundredToScaleOfTen = (value: number): number => {
  const result = value / 10;
  if (result < 0) {
    return 0;
  }
  if (result > 10) {
    return 10;
  }
  return round(result, 1);
};

/**
 * Hashes a string to a number in the range of 0-maxValue
 * @param string - The string to hash
 * @param maxValue - The maximum value to hash to
 * @returns The hashed number
 */
export const getHashInRange = (string: string, maxValue: number) => {
  const p = 31;
  const m = 1e9 + 9;
  let hash_value = 0;
  let p_pow = 1;
  for (let i = 0; i < string.split('').length; i++) {
    hash_value = (hash_value + (string[i].charCodeAt(0) - 97 + 1) * p_pow) % m;
    p_pow = (p_pow * p) % m;
  }
  return Math.abs(hash_value % maxValue);
};
